import styled from 'styled-components';

import { media } from '../../../styles/constants';

const PhonesImageContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;

  > div {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: calc(50% - 1.3rem);

    &:first-child {
      padding-right: 1.3rem;
    }
  }

  @media (min-width: ${media.tabletLandscape}) {
    > div {
      flex-basis: calc(50% - 3rem);

      &:first-child {
        padding-right: 3rem;
      }
    }
  }
`;

export default PhonesImageContainer;
